<template>
  <div>
    <v-data-table
      :headers="headersTable"
      :items="itemsTable"
      :search="searchField"
      :hide-default-footer="true"
      disable-pagination
      item-key="date"
      dense
      class="elevation-1"
      no-data-text="Нет данных для создания таблицы"
    >
      <template #top v-if="search">
        <v-text-field
          v-model="searchField"
          prepend-icon="mdi-magnify"
          dense
          hide-details
          class="pa-2"
        ></v-text-field>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headersTable: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemsTable: {
      type: Array,
      required: true,
      default: () => [],
    },
    search: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      searchField: '',
    }
  }
};
</script>
